// --- TheLandmark: Persistent hook installer ---
// Safely attach preview/job flow to the existing coordinateGrabberWidget at runtime.
// This is appended at EOF to avoid interfering with main logic and conditional blocks.
(function(){
  function attachLandmarkHook(){
    try{
      const inst = window.coordinateGrabberWidget;
      if (!inst) return; // widget not present yet
      if (inst.__landmarkHooked) {
        return; // already attached
      }

      // Prefer step-3 if present, fall back to step-2, then document
      function findStepRoot(){
        return inst.step3Content || document.getElementById('step-3-content') ||
               inst.step2Content || document.getElementById('step-2-content') ||
               document;
      }

              function ensurePreviewSlot(){
          const root = findStepRoot();
          if (!root || !root.querySelector) return null;
          
          // In Step 3, look for the existing preview container
          const step3Root = inst.step3Content || document.getElementById('step-3-content');
          if (step3Root && root === step3Root) {
            const existingPreviewContainer = root.querySelector('.preview-container');
            if (existingPreviewContainer) {
              // Use the existing Step 3 preview container
              let status = existingPreviewContainer.querySelector('#topomap-preview-status');

              
              // Remove old PNG preview image creation - we use GLB viewer now
              
              if (!status) {
                status = document.createElement('div');
                status.id = 'topomap-preview-status';
                status.className = 'preview-status';
                status.style.cssText = 'font-size: 13px; color: #666; font-style: italic;';
                existingPreviewContainer.insertBefore(status, img);
              }
              

              
              return existingPreviewContainer;
            }
          }
        
        // Fallback for other steps - create minimal preview block
        let block = root.querySelector('#topomap-preview');
        if (!block){
          block = document.createElement('div');
          block.id = 'topomap-preview';
          block.style.cssText = 'margin-top:16px';
          block.innerHTML =
            '<div id="topomap-preview-status" style="font-size:13px;opacity:.8;margin-bottom:6px"></div>';
          
          const anchor = root.querySelector('.map-snapshot-section') ||
                         root.querySelector('.final-summary') ||
                         root.querySelector('.final-controls') || root;
          if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(block, anchor.nextSibling);
          else if (root.appendChild) root.appendChild(block);
          else document.body.appendChild(block);
        }
        
        // Hide preview entirely if we're in step 2
        const step2Root = inst.step2Content || document.getElementById('step-2-content');
        if (step2Root && root === step2Root) {
          block.style.display = 'none';
        } else {
          block.style.display = 'block';
        }
        
        return block;
      }

      function setStatus(text, showDots = false){
        const root = findStepRoot();
        const el = root && root.querySelector && root.querySelector('#topomap-preview-status');
        
        if (el) {
          // Clear any existing animation
          if (el.__dotAnimation) {
            clearInterval(el.__dotAnimation);
            el.__dotAnimation = null;
          }
          
          // Check if this is a rate limit message and style accordingly
          const isRateLimit = text.includes('too many jobs') || text.includes('too quickly');
          
          if (isRateLimit) {
            // Style rate limit messages with warning appearance
            el.style.color = '#dc3545'; // Red color
            el.style.fontWeight = '600';
            el.style.backgroundColor = '#f8d7da';
            el.style.border = '1px solid #f5c6cb';
            el.style.borderRadius = '4px';
            el.style.padding = '8px 12px';
            el.style.margin = '8px 0';
          } else {
            // Reset to normal styling
            el.style.color = '';
            el.style.fontWeight = '';
            el.style.backgroundColor = '';
            el.style.border = '';
            el.style.borderRadius = '';
            el.style.padding = '';
            el.style.margin = '';
          }
          
          if (showDots) {
            // Add animated dots
            let dotCount = 0;
            const baseText = text;
            el.textContent = baseText;
            
            el.__dotAnimation = setInterval(() => {
              dotCount = (dotCount + 1) % 4;
              const dots = '.'.repeat(dotCount);
              el.textContent = baseText + dots;
            }, 500);
          } else {
            // Static text
            el.textContent = text || '';
          }
          
          // Hide status text in step 2 and step 3 (step 3 uses GLB viewer progress)
          const step2Root = inst.step2Content || document.getElementById('step-2-content');
          const step3Root = inst.step3Content || document.getElementById('step-3-content');
          const isInStep2 = step2Root && root === step2Root;
          const isInStep3 = step3Root && root === step3Root;
          el.style.display = (isInStep2 || isInStep3) ? 'none' : 'block';
        }
      }

      function showImage(url){
        // Old PNG preview function - no longer used with GLB viewer
        return;
        const step2Root = inst.step2Content || document.getElementById('step-2-content');
        const isInStep2 = step2Root && root === step2Root;
        
        // Check if we're in step 3 for proper sizing
        const step3Root = inst.step3Content || document.getElementById('step-3-content');
        const isInStep3 = step3Root && root === step3Root;
        
        img.onload = function(){ 
          if (isInStep2) {
            img.style.display = 'none';
          } else {
            img.style.display = 'block';
            // Apply Step 3 specific sizing
            if (isInStep3) {
              img.style.maxWidth = '1000px';
              img.style.width = '100%';
              img.style.height = 'auto';
            }
          }
        };
        img.onerror = function(){ 
          img.onerror = null; 
          img.src = ''; 
          setStatus('Preview placeholder shown'); 
          img.style.display = isInStep2 ? 'none' : 'block';
        };
        
        if (url) {
          if (url.charAt(0) === '/') {
            // Convert relative URLs to full backend URLs
            if (url.startsWith('/apps/landmark/')) {
              // Use validated backend URL from coordinate widget
          const backendUrl = window.coordinateGrabberWidget?.backendUrl || 'https://thelandmark-api-preview.fly.dev';
              url = backendUrl + url.replace('/apps/landmark', '');
            } else {
              url = window.location.origin + url;
            }
          }
          img.src = url;
        } else {
          img.src = '';
          setStatus('Preview placeholder shown');
          img.style.display = isInStep2 ? 'none' : 'block';
        }
      }

      async function startJob(){
        
        if (!inst.currentSelectedArea) { 
          setStatus('No area selected'); 
          return; 
        }
        
        // Prevent multiple simultaneous job starts
        if (inst.__landmarkJobStarting) {
          return;
        }
        
        // Prevent starting if we already have a job ID
        if (inst.__landmarkJobId) {
          return;
        }
        
        inst.__landmarkJobStarting = true;
        
        const a = inst.currentSelectedArea;
        const payload = {
          bbox: { tr: [a.topRight.lat, a.topRight.lng], bl: [a.bottomLeft.lat, a.bottomLeft.lng] },
          engraving: (inst.placeName || ''),
          sku: (typeof inst.detectedSku === 'string' ? inst.detectedSku : ''),
          rotation: (a.rotation || 0) // Include rotation state
        };
        
        ensurePreviewSlot();
        
        // Start with initial status - removed redundant message
        
        try {
          // Use validated backend URL from coordinate widget
          const backendUrl = window.coordinateGrabberWidget?.backendUrl || 'https://thelandmark-api-preview.fly.dev';
          
          const res = await fetch(backendUrl + '/jobs', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(payload)
          });
          
          
          // Handle rate limiting
          if (res.status === 429) {
            const errorData = await res.json();
            
            // Show user-friendly rate limit message
            let rateLimitMessage = 'You\'ve created too many jobs this hour, please wait 15 minutes before creating more jobs (it costs us money to generate these!)';
            
            // If we have more specific error details, use them
            if (errorData.detail && errorData.detail.error) {
              if (errorData.detail.error.includes('job creation limit')) {
                rateLimitMessage = 'You\'ve created too many maps this hour, please wait 15 minutes before creating more (it costs us money to generate these!)';
              } else if (errorData.detail.error.includes('rate limit')) {
                rateLimitMessage = 'You\'re making requests too quickly, please slow down and wait a few minutes before trying again.';
              }
            }
            
            setStatus(rateLimitMessage);
            
            // Reset flags so user can retry later
            inst.__landmarkJobStarting = false;
            inst.__landmarkJobStarted = false;
            return;
          }
          
          // Handle other errors
          if (!res.ok) {
            const errorText = await res.text();
            console.error('[TheLandmark] Job creation failed:', res.status, errorText);
            setStatus('Error starting preview - please try again');
            inst.__landmarkJobStarting = false;
            inst.__landmarkJobStarted = false;
            return;
          }
          
          const data = await res.json();
          
          if (!data || !data.job_id) throw new Error('no job_id in response');
          inst.__landmarkJobId = data.job_id;
          
          // Update status to show job is queued
          setStatus('Job queued, starting processing (this could take a few seconds)', true);
          
          pollJob();
        } catch(err){
          console.error('[TheLandmark] start job failed', err);
          setStatus('Error starting preview');
          // Reset flags on error so user can retry
          inst.__landmarkJobStarting = false;
          inst.__landmarkJobStarted = false;
        } finally {
          inst.__landmarkJobStarting = false;
        }
      }

      function pollJob(){
        if (!inst.__landmarkJobId) return;
        if (inst.__landmarkTimer) clearInterval(inst.__landmarkTimer);
        
        async function tick(){
          try{
            ensurePreviewSlot();
            // Use validated backend URL from coordinate widget
          const backendUrl = window.coordinateGrabberWidget?.backendUrl || 'https://thelandmark-api-preview.fly.dev';
            const r = await fetch(backendUrl + '/jobs/' + inst.__landmarkJobId);
            const d = await r.json();
            
            if (d && d.status === 'done'){
              clearInterval(inst.__landmarkTimer); inst.__landmarkTimer = null;
              
              // Show completion
              setStatus('Preview ready ✔︎');
              
              const assets = d.assets || {};
              const url = assets.preview_url || assets.heightmap_url || '';
              inst.__landmarkPreviewUrl = url || '';
              
              // Store all R2 file URLs for cart/order integration
              inst.__landmarkFileUrls = {
                preview_url: assets.preview_url || '',
                // stl_url removed - GLB-only pipeline
                normal_url: assets.normal_url || ''
              };
              
              if (url){
                showImage(url);
              } else {
                showImage('');
                setStatus('Preview ready (no image URL).');
              }
            } else if (d && d.status === 'queued'){
              setStatus('Queued (this could take a few seconds)', true);
            } else if (d && d.status === 'processing'){
              setStatus('Processing (this could take a few seconds)', true);
            } else if (d && d.status === 'error'){
              clearInterval(inst.__landmarkTimer); inst.__landmarkTimer = null;
              setStatus('Error generating preview');
              
              // Reset flags on error so user can retry
              inst.__landmarkJobStarted = false;
            } else {
              // Backend is processing - show simple status
              setStatus('Processing (this could take a few seconds)', true);
            }
          }catch(e){
            setStatus('Connection error, retrying (this could take a few seconds)', true);
          }
        }
        // run immediately then poll
        tick();
        inst.__landmarkTimer = setInterval(tick, 1500);
      }

      // Single watcher function: watch whichever step root we prefer (step-3 then step-2).
      function watchStepRootAndStart(inst){
        try {
          const root = findStepRoot();
          if (!root) return;
          
          // Prevent multiple job starts - add a flag to track if we've already started watching
          if (inst.__landmarkWatching) {
            return;
          }
          inst.__landmarkWatching = true;
          
          function isVisible(){
            if (root.classList && !root.classList.contains('hidden')) return true;
            const cs = getComputedStyle(root);
            return cs && cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
          }
          
          // CRITICAL FIX: Only start job if we're in Step 1 and haven't started yet
          // Don't start jobs when navigating between steps
          if (isVisible()){
            // Only start job if we're in Step 1 (map selection) and haven't started a job yet
            const isInStep1 = !inst.step2Content || inst.step2Content.classList.contains('hidden');
            if (isInStep1 && !inst.__landmarkJobId && inst.currentSelectedArea && !inst.__landmarkJobStarted) {
              // DISABLED: Legacy V2 job creation - now using V3 generateGLBPreview() instead
              inst.__landmarkJobStarted = true; // Mark as started to prevent legacy calls
            } else {
            }
            return;
          }
          
          // CRITICAL FIX: Don't watch for step changes to start jobs
          // Only watch for initial Step 1 visibility
        } catch (err) {
          console.warn('[TheLandmark] watchStepRootAndStart failed', err);
        }
      }

      // Hook in: ensure global watch installed only once (keeps idempotency)
      try {
        if (!window.__TheLandmark_WatchInstalled) {
          window.__TheLandmark_WatchInstalled = true;
          document.addEventListener('DOMContentLoaded', function(){
            setTimeout(function(){
              const candidate = window.coordinateGrabberWidget || window.__landmark_candidate_instance;
              if (candidate) watchStepRootAndStart(candidate);
            }, 50);
          });
        }
        
        // CRITICAL FIX: Only call watchStepRootAndStart if we haven't already done so for this instance
        if (!inst.__landmarkWatching) {
          watchStepRootAndStart(inst);
        } else {
        }
      } catch(e){
        console.warn('[TheLandmark] failed to schedule watcher', e);
      }

      // Wrap confirmCoordinates so it starts a job after user confirms area
      try {
        const originalConfirm = inst.confirmCoordinates && inst.confirmCoordinates.bind(inst);
        if (originalConfirm) {
          inst.confirmCoordinates = function(){
            const ret = originalConfirm();
            // DISABLED: Legacy V2 job creation after confirm - now using V3 generateGLBPreview() instead
            return ret;
          };
          inst.__landmarkHooked = true;
        } else {
          console.warn('[TheLandmark] confirmCoordinates not present to wrap');
        }
      } catch(e){
        console.error('[TheLandmark] failed to attach confirm wrapper', e);
      }
    } catch(e) {
      console.warn('[TheLandmark] attachLandmarkHook error', e);
    }
  }

        // Try to attach as soon as DOM and widget are ready
      if (document.readyState === 'complete' || document.readyState === 'interactive'){
        setTimeout(attachLandmarkHook, 50);
      } else {
        window.addEventListener('DOMContentLoaded', attachLandmarkHook);
        window.addEventListener('load', attachLandmarkHook);
      }


    })();

// --- End of appended TheLandmark hook ---

























